module.exports = __webpack_public_path__ + "img/no.bbd1c0e8.png";